import { defineMessages } from 'react-intl';

export default defineMessages({
    EndorsementPoliciesHeader: {
        id: 'cep.components.sgEndorsementPolicies.EndorsementPoliciesHeader',
        defaultMessage: 'Select policy to change'
    }
});
